import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "confirmation",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalHeader = _resolveComponent("ModalHeader")!
  const _component_ModalBody = _resolveComponent("ModalBody")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.includeModalHeader)
          ? (_openBlock(), _createBlock(_component_ModalHeader, { key: 0 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(this.title), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_ModalBody, null, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "p-1",
              innerHTML: _ctx.message
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        }),
        _createVNode(_component_ModalFooter, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.modalButtons, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", { key: idx }, [
                (!_ctx.isCloseButton(item.label))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["btn", item.css]),
                        onClick: ($event: any) => (_ctx.fn(item.callback))
                      }, _toDisplayString(item.label), 11, _hoisted_6)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isCloseButton(item.label))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (!item.callback)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: _normalizeClass(["btn", item.css]),
                            "data-bs-dismiss": "modal"
                          }, _toDisplayString(item.label), 3))
                        : _createCommentVNode("", true),
                      (item.callback)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: _normalizeClass(["btn", item.css]),
                            onClick: ($event: any) => (_ctx.fn(item.callback))
                          }, _toDisplayString(item.label), 11, _hoisted_8))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _: 1
        })
      ])
    ])
  ], 512))
}